// src/components/cctv/CameraView.js
import React from "react";
import { ChevronLeft } from "lucide-react";
import { useAtom } from "jotai";
import { CCTV } from "../../atomstore/store";

const CameraView = ({ onBack, streamUrl }) => {
    // const [streamUrl] = useAtom(CCTV)
    const isM3U8 = streamUrl?.includes(".m3u8");

    console.log("st", streamUrl)

    return (
        <div className="fixed inset-0 bg-black flex flex-col z-50">

            {/* HEADER */}
            <div className="flex items-center justify-between p-4 bg-gray-900">
                <button onClick={onBack} className="text-white">
                    <ChevronLeft className="w-6 h-6" />
                </button>
                <h2 className="text-white font-semibold cursor-pointer" onClick={onBack}>Live Camera</h2>
                <div className="w-6"></div>
            </div>

            {/* PLAYER */}
            <div className="flex-1 flex items-center justify-center bg-black">
                {isM3U8 ? (
                    <video
                        src={streamUrl}
                        autoPlay
                        controls
                        playsInline
                        className="w-full h-full object-contain"
                    />
                ) : (
                    <iframe
                        title="cctv"
                        src={streamUrl}
                        className="w-full h-full"
                        allowFullScreen
                        frameBorder="0"
                    />
                )}
            </div>

        </div>
    );
};

export default CameraView;
